<div class="modal-backdrop" *ngIf="showModal" (click)="close()"></div>

<div class="modal-container" *ngIf="showModal">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <div class="modal-title">
        <i class="fas fa-lock"></i>
        <h2>Encerrar Ordem de Serviço</h2>
      </div>
      <button class="btn-close" (click)="close()" type="button">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="modal-body">
      <div class="current-os-info">
        <i class="fas fa-file-alt"></i>
        <div>
          <small>Ordem de Serviço</small>
          <strong>{{ ordemServico }}</strong>
        </div>
      </div>

      <div class="alert alert-info mt-3" *ngIf="sugerido">
        <i class="fas fa-check-circle"></i>
        O serviço foi finalizado<span *ngIf="statusAtual"> (status "{{ statusAtual }}")</span>.
        Confirme a data e a hora do fechamento.
      </div>

      <div class="alert alert-danger mt-3">
        <i class="fas fa-exclamation-triangle"></i>
        Uma OS encerrada <strong>não poderá ser reaberta</strong>. Orçamentos ainda abertos vinculados a ela
        também serão cancelados.
      </div>

      <form class="close-form">
        <div class="form-row">
          <div class="form-group">
            <label for="dataFechamento">Data do fechamento <span class="required">*</span></label>
            <input
              type="date"
              id="dataFechamento"
              class="form-control"
              [(ngModel)]="dataFechamento"
              [ngModelOptions]="{standalone: true}"
              [max]="maxData"
              [min]="minData">
          </div>

          <div class="form-group">
            <label for="horaFechamento">Hora do fechamento <span class="required">*</span></label>
            <input
              type="time"
              id="horaFechamento"
              class="form-control"
              [(ngModel)]="horaFechamento"
              [ngModelOptions]="{standalone: true}">
          </div>
        </div>

        <small class="form-text text-muted">
          <i class="fas fa-history"></i>
          Já vem preenchido com a data e a hora atuais. Altere para registrar um fechamento retroativo.
        </small>

        <div class="alert alert-warning mt-3" *ngIf="isRetroativo && !erroValidacao">
          <i class="fas fa-clock"></i>
          Fechamento retroativo: a OS será encerrada com
          <strong>{{ formatBr(dataFechamento) }} às {{ horaFechamento }}</strong>.
        </div>

        <div class="alert alert-danger mt-3" *ngIf="erroValidacao">
          <i class="fas fa-times-circle"></i>
          {{ erroValidacao }}
        </div>
      </form>
    </div>

    <div class="modal-footer">
      <button class="btn btn-secondary" (click)="close()" type="button">
        <i class="fas fa-times"></i>
        {{ sugerido ? 'Encerrar depois' : 'Cancelar' }}
      </button>
      <button
        class="btn btn-danger"
        (click)="confirmar()"
        type="button"
        [disabled]="!!erroValidacao">
        <i class="fas fa-lock"></i>
        Encerrar OS
      </button>
    </div>
  </div>
</div>
